module.exports = __webpack_public_path__ + "static/media/mg_group_ui_assets_conyuge.12fed300.svg";